import React from 'react'

import Container from './styles'

function ReviewButton(props) {
  const { id, color, backgroundColor, borderColor, icon, onClick, text } = props
  return (
    <Container
      id={id} 
      style={{
        color, 
        backgroundColor,
        borderColor,
      }}
      onClick={onClick}
    >
      <span id={id}>{icon}</span>
      <span id={id}>{text}</span>
    </Container>
  )
}

export default ReviewButton
